import React, { Component } from 'react';
import { Affix, Col, Menu, Row } from 'antd';
import { AiOutlineMenu } from 'react-icons/ai';

export default class Header extends Component {
  state = {
    openKeys: []
  };

  render() {
    const { SubMenu } = Menu;

    this.onOpenChange = (keys) => {
      //clicking submenu
      this.setState({
        openKeys: keys
      });
    };

    this.onSelect = (e) => {
      //clicking submenu item
      this.setState({
        openKeys: []
      });
    };

    return (
      <Row>
        <Col xs={24}>
          <Affix offsetTop={0}>
            <div className="container-logo">
              <div className="container-logo-content">
                <img className="primary-logo hide-mob" src="./wsu-logo-white.svg" alt="Western Sydney University" />
                <img className="primary-logo show-mob" src="./wsu-shield-white.svg" alt="Western Sydney University" />
                <h1 className="site-title">Cortex Template Icons</h1>
              </div>
              <div className="container-menu-content">
                <Menu 
                    overflowedIndicator={<AiOutlineMenu />}
                    mode="inline"
                    onSelect={this.onSelect}
                    className="site-menu"
                    theme={"dark"}
                    onOpenChange={this.onOpenChange}
                    openKeys={this.state.openKeys}
                  >
                    <SubMenu key="sub1" icon={<AiOutlineMenu />} title="Menu">
                      <Menu.Item key="1"><a href="#zone-icons">Zone Icons</a></Menu.Item>
                      <Menu.Item key="2"><a href="#content-area-icons">Content Area Icons</a></Menu.Item>
                      <Menu.Item key="3"><a href="#other-icons">Other Icons</a></Menu.Item>
                      <Menu.Item key="4"><a href="#ui-icons">UI Icons</a></Menu.Item>
                    </SubMenu>
                  </Menu>
                </div>
            </div>
          </Affix>
        </Col>

        <Col xs={24}> 
          <div className="container-byline">
            <div className="container-byline-content">
              <Row justify={"center"}>
                <Col xs={24} sm={19} md={16} lg={12} xl={10}>
                    <h2>Cortex is the official VLE theme for all Western Sydney University subject sites</h2>
                    <hr/>
                    <p>Use the below naming conventions for Blackboard Items to display unique icons and give content greater visual context</p>
                </Col>
              </Row>
            </div>
          </div> 
        </Col>
      </Row>
    )
  }
}